module.exports = __webpack_public_path__ + "img/dollar-yellow.05cc602d.png";